import React from 'react';

import {
  Box,
  Button,
  MenuItem,
  Select,
  TextField
} from '@mui/material';

import {
  Add,
  Search
} from '@mui/icons-material';

const fieldSx = {
  '& .MuiOutlinedInput-root': {
    height: 40,
    bgcolor: '#FFFFFF',
    fontSize: 13,

    '& fieldset': {
      borderColor: '#D9D9D9'
    }
  }
};

const AppointmentFilters = () => {
  return (
    <Box
      sx={{
        p: 1.5,
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          lg: '1.1fr 1fr 1fr auto'
        },
        gap: 1.25,
        borderBottom: '1px solid #E0E0E0'
      }}
    >
      <TextField
        placeholder="Search appointment..."
        size="small"
        sx={fieldSx}
        slotProps={{
          input: {
            startAdornment: (
              <Search
                sx={{
                  mr: 1,
                  fontSize: 20,
                  color: '#757575'
                }}
              />
            )
          }
        }}
      />

      <Select
        defaultValue="allLocations"
        size="small"
        sx={{
          height: 40,
          fontSize: 13
        }}
      >
        <MenuItem value="allLocations">
          All Locations
        </MenuItem>

        <MenuItem value="location1">
          Location 1
        </MenuItem>

        <MenuItem value="location2">
          Location 2
        </MenuItem>
      </Select>

      <Select
        defaultValue="allProviders"
        size="small"
        sx={{
          height: 40,
          fontSize: 13
        }}
      >
        <MenuItem value="allProviders">
          All Providers
        </MenuItem>

        <MenuItem value="provider1">
          Dr. James
        </MenuItem>

        <MenuItem value="provider2">
          Dr. Philip
        </MenuItem>
      </Select>

      <Button
        variant="outlined"
        startIcon={<Add />}
        sx={{
          height: 40,
          px: 2.25,
          whiteSpace: 'nowrap',
          color: '#424242',
          bgcolor: '#FFF9EE',
          borderColor: '#E8D3A8',
          fontSize: 12,
          fontWeight: 600,

          '&:hover': {
            bgcolor: '#FFF3DC',
            borderColor: '#DDBF84'
          }
        }}
      >
        Schedule Appointment
      </Button>
    </Box>
  );
};

export default AppointmentFilters;